import React from "react";
import { Box } from "@mui/material";
import Header from "../components/Header";
import WhatsAppFloatButton from "../components/WhatsAppFloatButton";

import Hero from "../sections/Hero";
import Sobre from "../sections/Sobre";
import Videos from "../sections/Videos";
import Fotos from "../sections/Fotos";
import Equipe from "../sections/Equipe";
import Numeros from "../sections/Numeros";
import Contato from "../sections/Contato";
import { HEADER_HEIGHT } from "../utils/anchors";
import Footer from "../components/Footer";

export default function Home() {
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "var(--preto)" }}>
            <Header />
            <Box sx={{ height: HEADER_HEIGHT }} />

            <Hero />
            <Sobre />
            <Numeros />
            <Videos />
            <Fotos />
            <Equipe />
            <Contato />

            <Footer />
            <WhatsAppFloatButton />
        </Box>
    );
}